var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-layered-map__wrapper" },
    [
      _vm.desktop
        ? _c(
            "div",
            { staticClass: "c-map-nav" },
            [
              _vm.map
                ? _c("MapSearch", {
                    attrs: {
                      map: _vm.map,
                      config: _vm.config.componentConfiguration,
                      id: "desktop-search"
                    },
                    on: { searchLocation: _vm.searchLocation }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.getNavButtons, function(button) {
                return _c(
                  "a",
                  {
                    key: button.index,
                    staticClass: "c-button c-button--brand",
                    attrs: {
                      role: "button",
                      href: button.url,
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(button.title))]
                )
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "c-map-nav__icon",
                attrs: {
                  type: "button",
                  "aria-label": "Expand map",
                  tabindex: "0"
                },
                on: {
                  click: _vm.expandMap,
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.expandMap($event)
                  }
                }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "MapLoader",
        {
          attrs: { apiKey: _vm.config.apiKey, isDesktop: _vm.desktop },
          on: { mapCreated: _vm.mapCreated }
        },
        [
          _c(
            "div",
            { attrs: { slot: "features" }, slot: "features" },
            [
              _c(
                "div",
                {
                  staticClass: "c-layered-map__sidebar-wrapper",
                  class: _vm.showSidebar ? "is-active" : null
                },
                [
                  _c("div", {
                    staticClass: "c-layered-map__sidebar-overlay",
                    on: {
                      click: function() {
                        return (this$1.showSidebar = false)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "c-layered-map__sidebar" },
                    [
                      _c(
                        "div",
                        { staticClass: "c-layered-map__sidebar-header" },
                        [
                          _vm.sidebarItems && _vm.getLocationTitle()
                            ? _c(
                                "h2",
                                {
                                  staticClass: "c-layered-map__sidebar-heading"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.getLocationTitle()) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-layered-map__sidebar-action" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "c-button c-button--cover",
                                  attrs: { "aria-label": "Close the modal" },
                                  on: {
                                    click: function() {
                                      return (this$1.showSidebar = false)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "c-button__icon",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xmlns:xlink":
                                            "http://www.w3.org/1999/xlink",
                                          "xlink:href": "#map-close"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.sidebarItems, function(item) {
                        return _c(
                          item.location.publicUrl ? "a" : "div",
                          {
                            key: item.index,
                            tag: "a",
                            staticClass: "c-layered-map__sidebar-item",
                            class: item.location.publicUrl
                              ? "c-layered-map__sidebar-item--link"
                              : null,
                            attrs: {
                              role: "button",
                              href: item.location.publicUrl
                                ? item.location.publicUrl
                                : null
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "c-layered-map__sidebar-image",
                                style:
                                  "background-image: url(" +
                                  item.location.image.url +
                                  ")",
                                attrs: { alt: item.location.image.alt }
                              },
                              [
                                item.location.publicationDateRaw
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-layered-map__sidebar-date"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatDate(
                                                item.location.publicationDateRaw
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "c-layered-map__sidebar-status" },
                              [
                                item.location.contentStatusLabel
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "c-layered-map__sidebar-status-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.location.contentStatusLabel
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.location.contentStatus
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "c-layered-map__sidebar-status-text"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.location.contentStatus
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            item.location.title
                              ? _c(
                                  "h3",
                                  {
                                    staticClass: "c-layered-map__sidebar-title"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.location.title) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "c-layered-map__sidebar-description"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.location.body) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _vm.desktop
                ? _c(
                    "div",
                    { staticClass: "c-toggle-list--fixed" },
                    [
                      _vm.config
                        ? _c("MapToggleList", {
                            attrs: {
                              layers: _vm.layerState,
                              description: _vm.config.staticKeySubtitle,
                              showList: false,
                              title: _vm.config.staticKeyTitle,
                              toggle: true
                            },
                            on: {
                              onToggleLayerChecked: _vm.onToggleLayer,
                              onToggleLayerDisabled: _vm.onToggleLayer,
                              onToggleGroup: _vm.onToggleGroup
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.desktop
                ? _c("MapSearchModal", {
                    attrs: {
                      map: _vm.map,
                      id: "modal-search",
                      config: _vm.config.componentConfiguration,
                      modalContent: _vm.modalContent,
                      showModal: _vm.showSearchModal
                    },
                    on: {
                      "update:showModal": function($event) {
                        _vm.showSearchModal = $event
                      },
                      "update:show-modal": function($event) {
                        _vm.showSearchModal = $event
                      },
                      searchLocation: _vm.searchLocation,
                      onGeoLocation: _vm.onGeoLocation,
                      modalClose: _vm.modalClose
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.boundaries
                ? _c("MapBoundary", {
                    attrs: { points: _vm.boundaries, map: _vm.map }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.adhocPolygons, function(points) {
                return _c("MapPolygon", {
                  key: points.index,
                  attrs: { points: points, map: _vm.map },
                  on: {
                    polygonCreated: _vm.polygonCreated,
                    handlePolygonClick: _vm.handlePolygonClick
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "MapModal",
                {
                  attrs: {
                    modalContent: _vm.modalContent,
                    showModal: _vm.showModal,
                    id: _vm.activeModal,
                    desktop: _vm.desktop
                  },
                  on: {
                    "update:showModal": function($event) {
                      _vm.showModal = $event
                    },
                    "update:show-modal": function($event) {
                      _vm.showModal = $event
                    },
                    "update:id": function($event) {
                      _vm.activeModal = $event
                    },
                    modalClose: _vm.modalClose
                  }
                },
                [
                  _vm.mobileKey
                    ? _c(
                        "div",
                        {
                          staticClass: "c-toggle-list--full-width",
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _vm.config
                            ? _c("MapToggleList", {
                                attrs: {
                                  layers: _vm.layerState,
                                  description: _vm.config.staticKeySubtitle,
                                  showList: true,
                                  title: _vm.config.staticKeyTitle,
                                  toggle: false
                                },
                                on: {
                                  onToggleLayerChecked: _vm.onToggleLayer,
                                  onToggleLayerDisabled: _vm.onToggleLayer,
                                  onToggleGroup: _vm.onToggleGroup
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "c-layered-map__controls" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "c-layered-map__control c-layered-map__control--geo",
                    attrs: { "aria-label": "Search by geolocation" },
                    on: { click: _vm.onGeoLocation }
                  },
                  [
                    _c(
                      "svg",
                      { attrs: { "aria-hidden": "true", focusable: "false" } },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#geo-location"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "c-layered-map__control",
                    attrs: { "aria-label": "Map zoom in" },
                    on: { click: _vm.zoomIn }
                  },
                  [_vm._v("+")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "c-layered-map__control",
                    attrs: { "aria-label": "Map zoom out" },
                    on: { click: _vm.zoomOut }
                  },
                  [_vm._v("-")]
                )
              ])
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      !_vm.desktop
        ? _c(
            "div",
            { staticClass: "c-navigation-bar" },
            _vm._l(_vm.config.componentConfiguration.buttons, function(button) {
              return _c(
                "div",
                {
                  key: button.index,
                  staticClass: "c-navigation-bar__link",
                  on: {
                    click: function($event) {
                      return _vm.navClick(button)
                    }
                  }
                },
                [
                  !_vm.desktop
                    ? _c("div", { staticClass: "c-navigation-bar__icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: { "aria-hidden": "true", focusable: "false" }
                          },
                          [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": button.icon
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v("\n      " + _vm._s(button.title) + "\n    ")
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.desktop
        ? _c(
            "a",
            {
              staticClass: "c-bottom-sheet__button",
              on: { click: _vm.showBottomSheet }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "c-bottom-sheet__button-icon",
                  attrs: { "aria-hidden": "true", focusable: "false" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#arrow-up"
                    }
                  })
                ]
              ),
              _vm._v(
                "\n    " + _vm._s(_vm.config.contentOverflowLabel) + "\n  "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f2bb94c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2bb94c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/LayeredMap.vue
// module id = 669
// module chunks = 0